// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { StyledCard, StyledSurprise } from './style'
import { Table } from 'antd'

type Props = {
  symbol: string,
  pastEarningsTargets: Object[]
}

class TableCompanyHistory extends Component<Props> {

  render() {

    // --- Columns ---
    const columns: Object[] = [{
      title: 'Quarter',
      dataIndex: 'fiscalPeriod',
      key: 'fiscalPeriod'
    }, {
      title: 'Date',
      dataIndex: 'earningsDate',
      key: 'earningsDate',
      sorter: (a: Object, b: Object): number => +moment(a.earningsDateFull) - +moment(b.earningsDateFull)
    }, {
      title: 'ToD',
      dataIndex: 'releaseToD',
      key: 'releaseToD'
    }, {
      title: 'Estimate',
      dataIndex: 'estimatedEPS',
      key: 'estimatedEPS',
      sorter: (a: Object, b: Object): number => {

        // make sure there is a value
        const first: number = a.estimatedEPS === '--' ? 0 : Number(a.estimatedEPS.replace('$', ''))
        const second: number = b.estimatedEPS === '--' ? 0 : Number(b.estimatedEPS.replace('$', ''))

        return first - second
      }
    }, {
      title: 'Reported',
      dataIndex: 'reportedEPS',
      key: 'reportedEPS',
      sorter: (a: Object, b: Object): number => {

        // make sure there is a value
        const first: number = a.reportedEPS === '--' ? 0 : Number(a.reportedEPS.replace('$', ''))
        const second: number = b.reportedEPS === '--' ? 0 : Number(b.reportedEPS.replace('$', ''))

        return first - second
      }
    }, {
      title: '% Surprise',
      dataIndex: 'surpriseAmount',
      key: 'surpriseAmount',
      sorter: (a: Object, b: Object): number => {

        // make sure there is a value
        const first: number = a.surpriseAmount === '--' ? 0 : Number(a.surpriseAmount.replace('%', ''))
        const second: number = b.surpriseAmount === '--' ? 0 : Number(b.surpriseAmount.replace('%', ''))

        return first - second
      },
      render: (text: string, record: Object, index: number) => {

        const { surpriseAmount } = record

        return (
          <StyledSurprise amount={surpriseAmount}>
            {surpriseAmount}
          </StyledSurprise>
        )
      }
    }]

    // --- Props ---
    const { pastEarningsTargets } = this.props

    return (
      <StyledCard 
        loading={!pastEarningsTargets.length} 
        bordered={false} 
        title='Earnings History'>
        
        <Table 
          dataSource={pastEarningsTargets} 
          columns={columns}
          size="small"
          pagination={{ pageSize: 15 }}/>
      </StyledCard>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  pastEarningsTargets: state.earnings.pastEarningsTargets
})


export default connect(mapStateToProps, null)(TableCompanyHistory)



// WEBPACK FOOTER //
// ./src/components/table-company-history/index.js